import { Input, InputNumber } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

interface FormInputProps {
  value: string | number | null | undefined;
  fieldName: string;
  placeholder: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement> | any) => void;
  handleBlur: {
    (e: React.FocusEvent<any>): void;
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void;
  };
  error?: string;
  isError?: boolean;
  numberType?: boolean;
  disabled?: boolean;
  className?: string;

  textarea?: boolean;
  rows?: number;
  autoSize?: { minRows?: number; maxRows?: number };
  maxLength?: number;
  showCount?: boolean;
}

const FormInput: FC<FormInputProps> = ({
  value,
  fieldName,
  placeholder,
  handleChange,
  handleBlur,
  error,
  isError,
  numberType,
  disabled,
  className,

  autoSize,
  maxLength,
  rows,
  showCount,
  textarea,
}) => {
  const { t } = useTranslation();

  const renderNumberInput = () => (
    <InputNumber
      value={value}
      size="large"
      className={`mb-1.25 no-arrows ${className}`}
      placeholder={t(`${placeholder}`)!}
      disabled={disabled}
      onChange={(value) => handleChange({ target: { name: fieldName, value } })}
      onBlur={handleBlur}
      onWheel={(e: React.WheelEvent<HTMLInputElement>) =>
        e.currentTarget.blur()
      }
    />
  );

  const renderTextArea = () => (
    <TextArea
      value={(value as string) ?? ""}
      name={fieldName}
      className={`mb-1.25 ${className ?? ""}`}
      placeholder={t(placeholder)!}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={disabled}
      size="large"
      rows={rows}
      autoSize={autoSize} // например { minRows: 3, maxRows: 8 }
      maxLength={maxLength} // если нужно ограничить длину
      showCount={showCount} // счётчик символов
      allowClear
    />
  );

  const renderBasicInput = () => (
    <Input
      type="text"
      value={value || ""}
      name={fieldName}
      className={`mb-1.25 ${className}`}
      placeholder={t(`${placeholder}`)!}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={disabled}
      size="large"
      onWheel={(e: React.WheelEvent<HTMLInputElement>) =>
        e.currentTarget.blur()
      }
    />
  );

  const renderInput = () => {
    if (numberType) return renderNumberInput();
    if (textarea) return renderTextArea();
    return renderBasicInput();
  };

  return (
    <>
      {renderInput()}
      {!!isError && <div className="text-red-100 mt-1px">{t(`${error}`)}</div>}
    </>
  );
};

export { FormInput };
